/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Leave_Window_Open_NoticeInputs */



/**
* | output |
* | --- |
* | "Please leave this window open until syncing completes" |
*
* @param {Team_Sync_Leave_Window_Open_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_leave_window_open_notice = /** @type {((inputs?: Team_Sync_Leave_Window_Open_NoticeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Leave_Window_Open_NoticeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez laisser cette fenêtre ouverte jusqu’à la fin de la synchronisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte lassen Sie dieses Fenster so lange geöffnet, bis die Synchronisierung abgeschlossen ist.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si prega di lasciare aperta questa finestra fino al completamento della sincronizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, оставьте это окно открытым до завершения синхронизации.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deje esta ventana abierta hasta que se complete la sincronización.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请保持此窗口打开，直到同步完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("同期が完了するまでこのウィンドウを開いたままにしてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया सिंक्रोनाइज़ेशन पूरा होने तक इस विंडो को खुला रखें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, deixe esta janela aberta até que a sincronização seja concluída.")
	return /** @type {LocalizedString} */ ("Please leave this window open until syncing completes")
});